module.exports = __webpack_public_path__ + "img/16.52c645b9.jpg";